function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "gs_svg__b"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#d5dfff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gs_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#474747"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gs_svg__c",
  x1: 109.3,
  x2: 110.9,
  y1: 218.5,
  y2: 173.4,
  gradientTransform: "matrix(1.5 0 0 .65 40.5 0)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#gs_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gs_svg__d",
  x1: 125.9,
  x2: 126,
  y1: 316.4,
  y2: 337.2,
  gradientTransform: "matrix(1.23 0 0 .8 40.5 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b50000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffc500"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gs_svg__e",
  x1: 407.9,
  x2: 456.4,
  y1: 149.4,
  y2: 147.3,
  gradientTransform: "matrix(.56 0 0 1.76 40.5 0)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#gs_svg__b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gs_svg__f",
  x1: 215.8,
  x2: 229,
  y1: 103,
  y2: 103,
  gradientTransform: "matrix(.74 0 0 1.33 40.5 0)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#gs_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gs_svg__g",
  x1: 117.6,
  x2: 78.2,
  y1: 1040.4,
  y2: 1003.7,
  gradientTransform: "matrix(2.56 0 0 .38 40.5 0)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#gs_svg__b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gs_svg__h",
  x1: 264.7,
  x2: 255,
  y1: 246,
  y2: 226.4,
  gradientTransform: "matrix(.9 0 0 1.1 40.5 0)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#gs_svg__b"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#006",
  d: "M0 0h640v480H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  strokeWidth: "1pt"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0v33l403.2 261.7H454v-33L50.7 0H0zm454 0v33L50.7 294.6H0v-33L403.2 0H454z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M189.2 0v294.7h75.6V0h-75.6zM0 98.2v98.3h454V98.1H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c00",
  d: "M0 117.9v59h454v-59H0zM204.3 0v294.7h45.4V0h-45.4zM0 294.7l151.3-98.2h33.9L33.8 294.6H0zM0 0l151.3 98.2h-33.8L0 22V0zm268.8 98.2L420.1 0H454L302.6 98.2h-33.8zM454 294.7l-151.3-98.2h33.8L454 272.6v22z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#6a4c2d",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M463.8 350s-3 7.5-4.6 7.5c-1.6 0-7.6-3.2-7.6-3.2s-4.3 7-6.6 7.4c-2.2.4-8.2-1-8.2-1s-5.8 0-6-.9c-.2-.8.3-2.4.3-2.4s-8.3 6.5-10.1 6.1c-1.9-.4-8-8.2-8-8.2l-1 4.1-11.8-.4-10.3-6.6s-5.7 9.5-6 9.3c-.1-.2-10 2.2-10 2.2l-.6-1.8-6.6-4s5.1-7.1 5.1-7.3c0-.2-2.4-1-2.4-1l-3.7 3-7.6 5-7.7-3.5 3.3-6.2.4-4.5 6-9 73-71 36 66.4-5.3 20z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M515.6 354.3l19-.7-8-4 72.3-2.8-10.2-3.9-9-12.2-37.6-2.9s-2.8-2.1-7.4-1c-.2-3-3.7-6.8-3.7-6.8l-23-1.7-14.5 9.8 9.7 25 12.4 1.1z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#gs_svg__c)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: "1pt",
  d: "M121.3 150.8l2.2-7.6s4-6.6 4-9.4c0-3 2.8-6.4 2.8-6.4s9-2.6 10.8 2.9c9.6-14.5 20.8-.7 20.8-.7l3.1-3.6 6.4-7.8s9 8.4 9 9.9 1.6.4 1.6.4l9.8-.8s4.7 3.7 3.7 10.6c3.4 2 6.6 14 6.6 14l-80.8-1.5z",
  transform: "matrix(.86 0 0 .86 337.3 11.7)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#656263",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M515.5 218.7c1.4-.9 6-2.3 5.5-9-.6-6.7-6.4-7.5-9.6-7.3-3.3.3-6.2 3-6.2 3l-10.7-6.8s5.4-33.8 11-35.9c5.5-3.9 6.4-5.5 6.4-6.4s-2-3.2-2-3.2L475 149l-33 3.9s-2.6 3.9-2.2 5.5.4 3.2 6.3 7.8c6.6 5 11 33.9 11 33.9s-9.2 4.6-9.8 4c-.5-.6-3.3-1.1-4.7-.9-1.5.2-6.3 2.7-6.3 9 0 6.4 4.8 10 4.8 10s31.6-3.6 36.3 5.1c4.5-10.5 34.5-6.8 38.1-8.6z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 1.1,
  d: "M549.5 183.6s.4-3.7 3-5.4c2.6-1.8 20-2.6 24.3 0s5.7 15.5 5.7 15.5 2.6 4.6 2.8 7.9l.5 5.6s14 18.1 14.2 34.6c1.6 11.1 1.2 41-3.2 52.4-.1 14.1-6 23.4-6 23.4s1.3 2.4 1.2 5c-.2 2.7-1.6 5.1-1.6 5.1l20.4 10.1-7.5-2.8 7.5 6.3-8.5-4 5 5-12.4-5.5s5.8 5.4 5.4 5.2l-9.2-4.3 5.4 5.6c-.2-.3-8-3.5-8-3.5l.3 3s-6.3-.4-6.3-5.1a23 23 0 01-5.2-4.2l-14.5-2.5-16.4-49 3.8-83 1-4.2-1.7-11.2z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fb0",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M538.5 448.8s-8.4-17.8-12.6-18c-3.8-7.2 13.2-66.2 46-69.5 18 1.4 1.4 20.7-10.4 14.8 1.5 5.2 7.4 12.6 7.4 12.6s-23.5 10.1-30.4 60zm-112.7 2.5s7-20.1 11.2-20.4c4.2-.2-11.2-67-44.8-67.6-18.1 1.5-1.5 21 10.4 15-1.4 5.2-7.4 12.6-7.4 12.6s23.6 10.2 30.6 60.4z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#00713d",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M456.6 325.5c-.1-.1-8.4 2.6-3 11.6.4-3.5 4-5.6 4-5.6s-5.6 6.7.4 12.4c.7-5.3 4.1-7 4.1-7s-4.2 12.3.1 14.8c.5-4.9 3.7-7 3.7-7s-3.8 11-.4 13.5c.4-4.2 3.2-6 3.2-6s-1.7 11.4 2.7 12.2c.1-4 3.4-8 3.4-8s-1.5 9.4 5.5 9.8c0-3.5 1.3-7.6 1.3-7.6s3.2 10 7.8 8.3v-8.4s2.9 9.5 8.4 7.7c-.8-2.7.3-5.8.3-5.8s3 5.9 8.2 4c.9-1.8-.2-5.3-.2-5.3s7.6 8 10 3.2c2.3-4.8-6.2-6.4-6.2-6.4h5.8s-1.9-4.9-9.6-6c2.6-1.1 5.4-.3 5.4-.3s-1.6-6-9.6-6.7c3.1-1 6.5-.3 6.5-.3s-1-5.7-9.8-7.4c1.4-1.5 5.1-1 5.1-1s-3.5-5.4-7.4-5.1-39.8-3.6-39.7-3.6z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#3ec26d",
  strokeLinecap: "round",
  strokeWidth: 1.1,
  d: "M491.9 354.7s3.1 1.6 3 3m-1.1-5.5s4 2.9 4 5m-.5-6.4s3.2 2 3.4 5.2m2-4s1.6 3.6 1 4.2m2.3-2.3c.2 2.8-.3 3-.3 3m-39.6-20.4s3.8 2.5 3.5 5.9m-3.7-3s1.7 1.8 1.3 2.9m3.3-5.7s2.6 3.5 1.7 6m2.6-3.7s1.2 2.2.1 3.4m2-2.4s1.3 2.2.1 3m-1.7 4.2s3.6.8 4 3.5m-1.9-5.9s3.7.3 4.1 4.2m.9-5.6s2.5 4.3 2 5.7m2.7-5.3s1 4.2.3 5.5m2.8-3.8v4.7m-4.7-11.2s2.4.9 2.2 3.1m0-5.2s3 1.7 2.7 5m.8-6.4s2.6 3 1.6 6.5m2.9-5.8s-1 3.8-.6 5.4m3.3-2.8s-1.6 1.3-.7 3m-14 11.8s.6 3 0 3.4m-3.7-5s1.9 3.2 1.2 4.8m-5.2-5s2.1 2.4 2 4.3m-5.2-3.8s2 1.8 1.8 2.9m-3.5-.1s1.9 2 1.8 2.3"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M430.9 222.2l26.7-.5s17.7 0 19.6 5.8c3.4-7.7 18.6-7.2 18.6-7.2l27.7-1 .5 67a71.5 71.5 0 01-44.9 52 68.6 68.6 0 01-45.3-52.6l-3-63.5z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#006b00",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M440.4 222l39 103.8 35.2-106.1c-11 .7-34.4-1.7-37.3 8.3-4.5-9-29.1-5.4-36.9-6z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffc900",
  fillRule: "evenodd",
  stroke: "#006b00",
  strokeLinecap: "round",
  strokeWidth: 0.6,
  d: "M467 278.2c1.4.8 1.4-28.2 3.4-29.1l1.5-6c-1.7-3-9.3-2.8-12-.3a74.5 74.5 0 001.8 5.4c3.8 6.2 3 30.6 5.2 30z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#cdad56",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 1.1,
  d: "M456.5 54.3s2.8-3.1 2.9-3.9c.1-.7 12.5-1.2 19.9-15 4.1-7.2 0-3 0-3L479 29s5.1-4.9 3.3-7.5c-1.9-2.6-1.3 3.4-4.3 3.3-3-.2-1.4-6.5-1.4-6.5s-.2-.8-1-1.2c-1.3.2-1 2.4-2 2.7-1.2.2-2.2-5.3-2.2-5.3s-1.9-2.5-3.5 5.4c.9 8.4 6.2 6.7 6.2 12.2 0 5.5-4.7 9.8-6 10-1.5 0-1-4.7-1-4.7s-.7-2.3-1.2-2.3 2.7-.5 2.2-6.7c-1-7.5-2 1.7-4 1.4s-.5-7 .3-7.7-.9-3.8-5.3 4.2c-.4 3.8-.9-1-1.7-.8-1.5 3.1-1.3 5.4.9 8.3 3 2.8 5 5.7 5 7.2-.2 1.5-1.8 4.9-4 4.9s0-4.1 0-5.5c-.2-1.4-4-6.4-4-6.4s-2.6-4.2-2.3-4.4c.3 0-.3-.7-1.5 3.7s-2.8-3-2.8-3-1.7 5.5 2 8.7c-2.8-.4-3 .8-3 .8 0 1.5 3.8 2.1 4.3 4.7s-4 4.2-4 4.2 1.9 2.6 7.1-2.5c.1 3.2-2 5.5-2 5.5 1.8.8 3.1.7 3.4 2.7z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#cdad56",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.9,
  d: "M439.3 54.3s-2.3-3.5-2.4-4.1c-.1-.7-11.5.8-17-13-3.4-6.7 0-2.8 0-2.8l.3-3.2s-3.7-4.6-2.1-7c1.6-2.3 1 3.1 3 3.1 2.5 0 1.1-5.9 1.1-5.9s.2-.7 1-1c1 .1 1.5 3.5 2.4 3.8 1 .2 3-4 3.6-5 .9 0 .8-3.5 2.2 3.7-.7 7.6-7 6.1-7 11.2 0 5 4 8.8 5.2 9 1.1 0 .7-4.3.7-4.3s.6-2 1-2c.5 0-3.6.8-3.2-5 1-5.2 3 .4 4.8 0 1.7-.3-.2-5.5.3-6.4 0-.8 2.6-4.2 3.5 3.4.4 3.6 2.3-3 3-2.8 1.3 2.9-.5 6.7-2.3 9.3-2.7 2.6-4 5.5-3.8 6.8.1 1.4.7 3 2.6 3 2 0 .7-2.3.8-3.5.1-1.3 3.3-5.3 3.3-5.3.6-1 .1-3 .8-3.8 1 0 1.4-1.4 2.5 2.6 1 4 2.3-2.6 2.3-2.6s1.5 4.9-1.7 7.8c2.5-.3 2.7.7 2.7.7 0 1.4-1.2 2-1.6 4.3a4 4 0 001.3 3.8s-1.6 2.4-6.1-2.3a7.8 7.8 0 001.7 5c-1.5.7-2.7.7-2.9 2.5z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffc900",
  fillRule: "evenodd",
  d: "M508 237.4c-2.3-2-2.5-.2-3.7-.7-.5-.2-1-.8-1.5-1.2-.4-.5-.9-.7-1.5-.9l-.6 1.9c-.2.6.6 1.7.6 2.6-.2 1.4-.8 2.5-2.5 3 .5-1 .8-1 .6-2.2 0-.6-1.7-1.7-1.5-2.3.3-.9.8-2 .4-2.9-.7.5-1.6.3-2.4.6-.6.2-.6 1.4-1.4 1.8-1 .4-2.8.2-4.4-.7 1-.7 1.8-.2 2.7-1 .5-.3.5-1.9 1-2.3s1.6-.7 2.1-1c-.4-.6-.4-1.4-.8-1.9s-2.4-.4-2.8-.9c-.9-1-.7-2.3-1.6-3.3 2.2.9 2 2 2.5 1.9a4 4 0 012.7-.4c.5.2 1.6 1.6 2.2 1.9l.7-2c.2-.7-1-1.8-.7-2.4.4-1.3 1.4-2.4 1.9-3.6l.5 3.4c0 .6 1.2 1 1.3 1.5 0 .6-.6 2-.5 2.6l2.2-.1c.7-.2 1-1.7 1.7-1.8a8.4 8.4 0 013.6 0c-1 1-1.7 1-2.3 1.7-.5.4.1 1.6-1.3 2.5-.5.3-1.9 0-2.4.3l1.3 1.5s2.4.7 2.9 1.2c.9 1 1.3 2.2 1 3.3zm-59.8 1c2.3-2 2.6-.2 3.7-.7.6-.2 1-.7 1.5-1.2.4-.4 1-.6 1.5-.9l.6 2s-.6 1.6-.5 2.5c.1 1.4.7 2.6 2.4 3-.4-1-.7-1-.6-2.2 0-.6 1.8-1.7 1.6-2.2-.3-1-.9-2-.5-3 .8.6 1.7.3 2.4.6.6.3.6 1.4 1.5 1.8.9.4 2.8.2 4.3-.7-1-.7-1.7-.2-2.7-1-.5-.3-.5-1.9-1-2.2-.4-.4-1.6-.8-2-1.2.4-.5.3-1.2.8-1.7s2.3-.4 2.8-1c.9-1 .7-2.2 1.6-3.2-2.3.8-2 1.9-2.5 1.8-1.1-.5-2.2-.6-2.7-.4-.6.3-1.7 1.7-2.2 1.9l-.8-2c-.2-.7 1-1.8.8-2.4-.4-1.2-1.5-2.4-2-3.6 0 1.2-.3 2.2-.4 3.4-.1.6-1.3 1-1.4 1.5 0 .6.7 2 .6 2.7-.7-.2-1.6 0-2.3-.2-.6-.1-1-1.6-1.7-1.8a8.3 8.3 0 00-3.5.1c1 .9 1.7.8 2.3 1.7.5.3-.2 1.5 1.2 2.4.5.3 2 0 2.4.3l-1.3 1.5c-.4.5-2.4.7-2.8 1.2-1 1-1.4 2.2-1.1 3.3z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffc900",
  fillRule: "evenodd",
  stroke: "#006b00",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.6,
  d: "M506 244.1c-2.1 1.7-15.8 5.1-15.9 17-.1 11.8 2.4 14.5-.1 14.8-5 0-5.7-13.2-5.5-19 .1-5.9.3-5 .3-5s3.3 1 3 3.8c-.2 2.8 3.4-7 2.2-9.8 2.2 2.3 5.2 1.4 5.2 1.2 0-.1-1.7-2-2.4-3.3-.7-1.3 2.5.8 2.5.8s.1-2.3-2.7-2.1c-3.6 0 .6-1.2.6-1.2s2.1 2 3.5-.2a12 12 0 00-3.8-2.5s-2-3.8-4.6-4.5c-3.1-.8-2.7 1.3-6.2 1-.7 1.4-.7 1.5.7 2-2.4 1.6-1.1 5-1.1 5s3.8-1.7 3.6 1c-.1 2.7-2.2 2.2-3.6.6-1.3-.8-1.7.7-1.7.7l2 2.1s-3.9-.1-4.8 2.4c2-.1 3.2.5 3.2.5s-4.3 2-4.8 3c-.4 1-.5-1.2-.7-1.2l-4.2-1.5-1.4 6.5s2.8 2.8 4.4 1.9c1.5-1 4.3-3.6 6-2.9-5 3.8-9.8 9.2-12.5 10-.7-.7-3.1-3-4-1.9-1 1.2-.4 2.7.9 2.6 1.3-.2-4 1.2-3 3.4 1.2 2.3 1 2.1 2 1.5 1-.6-.8-.7 2.8-1.8 3.7-1 3.5-2 3.5-2s-.7 1.6-2.6 2c-2 .5-3.5.5-3.1 1 .4.7 1.2 1.7 1 2.3-.3.6 4-3.1 5.2-.1 3-.2 4.9-3.8 3.5-5.9.1 2.3 1.5 3 .7 4s6.6-3.4 3-6c1 2.2 1 4 1 4s1.8-.2 2.2-.8c.4-.6-.9 1.7-.3 2.1.6.5 3.2 3 2 4.8-.6-1-.7-2.7-1.6-2.5-.8.1-4.3 2.7-6.5 2.8s2.6 7.8 2.6 7.8-3.3-.4-3.7-.1c-.4.3-2.5-2.7-3-1-.6 2.3.8 1.4.8 1.4s-1.9-.9-2.8.2c-1 1-2 2-1.3 2.5s3.8.5 4.2.3-3.5.3-3.8.8c-.3.4-.8 2 0 2.7s3-.3 3.1-.8c.2-.4.3 1.7.3 1.7s3.6.3 3.6-3.5.3 2.7.3 2.7 3.7.6 3.8-3.1.4 2.5.4 2.5 2.4-.7 2.4-1.3c0-.6-.1 7.5-1.8 9.7-2.7-1.8-4.4 1.2-4.4 1.2s.2 4.3-.1 5.4c-.3 1 1.8-.6 2-1 .1-.5 2.6-1.7 2.8-2l.8-1.8s-.5 2.1-1.5 2.4-2 1.3-1.6 2.2c.5 1 2 1.5 2.6 2.4.5 1 2.5-5.2 2.5-5.2l.1 1.3s2.6-.6 2.9-1.8c.2-1.2-2.7-2.2-.3-4.2 2.4-1.9 0 1.8 0 1.8s.8 2.9 1.4 2.9 2-5.4.5-6.7c-1.4-1.4 2.1 1.6 2.1 1.6s2-5.5-.1-6.3l-3.1-1s1.1-1.5.6-1.7 3 3.3 3.5 2.4 1.4-3.6-2.7-5c-4-1.6-.1-5.8-.1-5.8s2.5 3 4.3 1.4c1.9-1.7-.1-1.7-.1-1.7s5.2-3.3 5.3-5l-2.6.2s3-2 2.2-5a3.5 3.5 0 01-2.7 1.6s2.6-2.6 2.1-5c-1.5 1.2-1.4 2.1-2.3 1.8s-2.7-9.7 1.2-10.3c4-.6 1.8 4.6 2 4.6.1 0 5.9-2.4 0-6.3 1.4-.4 4.4 2.3 4.4 2.3s-1.3-6.6-7.6-2.6c1.5-1.6 2.5-2.7 3.7-2.4 1.3.3 5.8-.1 5.8-1.5-1.1-.9-3.5.5-4.8 0-1.2-.4 9-1.2 8.2-6.3z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#006b00",
  strokeLinecap: "round",
  strokeWidth: 1.3,
  d: "M481.3 118.5s12.3-6.4 18.4 1.6m4.9 12.2c-.3 0-4.3 4-5.2 4m13.4 8.9s11.4.9 18.7-10.4",
  transform: "matrix(.46 0 0 .5 240.3 190.1)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#006b00",
  strokeLinecap: "round",
  strokeWidth: 1.3,
  d: "M525 141.8s1 6.1 2.8 6.1-3 1.6-4.9.3c2.2 2.8 3.4 7.7 0 9.5",
  transform: "matrix(.46 0 0 .5 240.3 190.1)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#e80000",
  fillRule: "evenodd",
  stroke: "#006b00",
  strokeLinecap: "round",
  strokeWidth: 1.3,
  d: "M519.3 219s-4 4.3-9 4.6",
  transform: "matrix(.46 0 0 .5 240.3 190.1)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#006b00",
  strokeLinecap: "round",
  strokeWidth: 1.3,
  d: "M523.9 199.4s-2.5-12.3-1-15.3c1-4 5-5.5 8-10.7m-8.3 17s-3 7.4-16.5 5m20.2-23.3s1 9.8-11.3 6.1m-3.7-50.2s-4.9 4.3-3 10.1",
  transform: "matrix(.46 0 0 .5 240.3 190.1)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#006b00",
  fillRule: "evenodd",
  d: "M483.7 247.6s3-1.2 3.6-1.8a9 9 0 001.8-2.7c.3-.9-2-2.3-.9-4.2.7-.9 1.7-1 3.4 0s-1.5-3.3-3.2-3.5-2.8 1.3-3.3 1c-.4-.3.2 1.2-.5 1.2s1.4 1.2 1.2 1.9c-.1.8 2.3 3.3 2.1 3.9 0 .6-3.5 4-4.2 4.2z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffc900",
  fillRule: "evenodd",
  stroke: "#ffc900",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "M534.3 97.1c2.8-.6 3.2 0 2.7 2.5a7 7 0 01-2.7-2.5z",
  transform: "matrix(.46 0 0 .5 240.3 190.1)"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fill: "#e80000",
  fillRule: "evenodd",
  stroke: "#006b00",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "M514.7 233.5s-1 6.4 1.5 7c-.1-2.5.5-4.2 1.2-4.9-.6-.2-2.6-2-2.7-2zm-5.7-7.9c-2.3-.3-6.2 1.6-5 4 1.8-1.7 3.6 0 4.9-1.6.4-.4.3-1.8.1-2.4zm0-4.5s-3.6-.6-4.1 1.9c2.5-.3 3.2-.6 4 0 .3-.6 0-1.8.1-2z",
  transform: "matrix(.46 0 0 .5 240.3 190.1)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fill: "#e80000",
  fillRule: "evenodd",
  stroke: "#006b00",
  strokeLinejoin: "round",
  strokeWidth: "1pt",
  d: "M493.5 185s2.2.8 2.9 3c1.7-1 2.5-5.8-2.9-3zm-5.4 5.4c.1 0 4.6-2.8 5-.2-.9 1-1.3 1.6-2 1.8-.6 0-1.8-1.8-3-1.6zm-.4 8.8s2.9-2.5 4-.8c1 1.6-1 1.5-1 1.5s-1-.4-3-.7zm-4-49.2s-3.6-1.4-5 1c2.3.4 3.1 1.2 4.2 2-.3-1-.8-2.6.8-3zm-6.9 18.5s.2-4.2 2.1-5.9c1.2.7 1.5 1.7 2.2 2.9-1.5.3-3.4.4-4.3 3zm9.5-3s-4 1.9-2.6 3.8c1.2-1.3 2.7-1 2.7-1l-.1-2.8z",
  transform: "matrix(.46 0 0 .5 240.3 190.1)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffc900",
  fillRule: "evenodd",
  stroke: "#006b00",
  strokeLinejoin: "round",
  strokeWidth: "1pt",
  d: "M480.6 125.6c-1.4 1.6 1.8 5 5 4.5 1-3.7-4.1-5.7-5-4.5z",
  transform: "matrix(.46 0 0 .5 240.3 190.1)"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M461.2 248.1c-.3.9 1 2 1.7 1.8.3-1-1.4-2.5-1.7-1.8z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fill: "#e80000",
  fillRule: "evenodd",
  stroke: "#006b00",
  strokeLinejoin: "round",
  strokeWidth: "1pt",
  d: "M484.3 122.8s.6 2.9 3.4 2.1c-.4-2.3-2.4-4-2.4-4-.1.7.4 1.7-1 1.9zm1.9 8.5s1.5 1.7 4.6-1.8c-1.4.4-3.8-.8-3.8-.8s0 2.4-.8 2.6z",
  transform: "matrix(.46 0 0 .5 240.3 190.1)"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffc900",
  fillRule: "evenodd",
  stroke: "#006b00",
  strokeLinejoin: "round",
  strokeWidth: "1pt",
  d: "M480.5 118.9c-1.4 1.5.5 3.7 3.8 3.2.9-3.7-3-4.4-3.8-3.2z",
  transform: "matrix(.46 0 0 .5 240.3 190.1)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#gs_svg__d)",
  fillRule: "evenodd",
  d: "M144.6 266.6s7-2 10.8 1 3.7.3 3.7.3 5.5 2 7 1.6-1 .1 1-1.2c2.2-1.2-4.2.3-4.8-2.4-1-1.7.1-3.9-2.2-3.2-1.5-2 1-3.4.5-5.6-1.6 1.2-2.5-.4-3.8 2.5-3-.6-.4-4.8-3.7-5.2 0 3-2.4 3.2-2.6 4.9-1.4 1-7.7 4.7-5.9 7.3z",
  transform: "matrix(.86 0 0 .86 337.3 11.7)"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fill: "#c01500",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M392 437.9c4-1 25.2 4.7 33.4 13.5-1.7-15.7-6-27.7-6-27.7s-12.8-3.6-14.5-1.9a96.3 96.3 0 00-13 16.1zm-6.5-72.3c-1.5.2-3 1.2-4.5 3.7-1.7 4.2-3 14.9-5.4 17.4-2.5 2.5-4.8 2.7-4.8 5 0 2.2.3 7.4 7 9.4 6.7.3 17.4-10.7 17.4-10.7s5.5-6 7.7-12.4c-13 4.5-22.1-7.5-17.4-12.4zm187 69.8c-4-1-25.4 4.7-33.6 13.4a133 133 0 016-27.5c1.6-.4 12.5-3.6 14.2-1.9 2.5 2.7 10.7 10.7 13.4 16zm6-72c1.5.3 2 2.3 3.2 4.7 1.7 4.2 3.5 10.4 6 12.8 2.5 2.5 4.7 6.2 4.7 8.4s-.5 5.2-7.2 7.2c-6.7.3-16.3-8.3-16.3-8.3s-5.4-6-7.7-12.4c12.9 4.5 21.2-7 17.3-12.3z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fill: "#fb0",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M378 424.2s13.5 9.2 13.7 13.5c36-53.5 128-70.1 180.5-3.8 7-9.2 14.2-12.1 14.2-12.1-55.2-72.2-165.1-63.2-208.4 2.4z"
});

var _ref34 = /*#__PURE__*/React.createElement("g", {
  fill: "#1e5aa6",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M515 219.9l5.2-.2-9.4 12 11.3 13-22.2 28 21 25.2a70 70 0 01-8.6 15.4l-12-13.3 21.8-27.2-18-20.3L515 220zm-75.2 2.3l-5.6.2 10.5 11.4-11.2 13.9 23.2 25.1-19.2 25.7a75.8 75.8 0 009.2 16.5l11.4-14.4-23.4-26 17.1-21.8-12-30.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M465.9 289.8l-8.3 11L487 335a74 74 0 0013.8-9.2L485.5 308l6.3-18.4 9 10.4-28.2 36a62 62 0 01-14.7-9.1l15-18.9-7-18.2zm-9.2-17.1l5.4 6.8-3.5-9.2-1.9 2.4zm38.6 6l4.3-5.8-1.6-2.2-2.7 8z"
}));

var _ref35 = /*#__PURE__*/React.createElement("text", {
  x: -328.3,
  y: 362.4,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "rotate(-49.4 182.5 -362) scale(.86)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -328.3,
  y: 362.4
}, "L"));

var _ref36 = /*#__PURE__*/React.createElement("text", {
  x: -292.3,
  y: 384.3,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.6 -.6 .6 .6 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -292.3,
  y: 384.3
}, "E"));

var _ref37 = /*#__PURE__*/React.createElement("text", {
  x: -239.8,
  y: 451.7,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.66 -.47 .5 .65 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -239.8,
  y: 451.7
}, "O"));

var _ref38 = /*#__PURE__*/React.createElement("text", {
  x: -188.5,
  y: 430,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.7 -.48 .48 .7 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -188.5,
  y: 430
}, "T"));

var _ref39 = /*#__PURE__*/React.createElement("text", {
  x: -115.4,
  y: 451.5,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.78 -.37 .37 .78 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -115.4,
  y: 451.5
}, "E"));

var _ref40 = /*#__PURE__*/React.createElement("text", {
  x: -94.1,
  y: 453.1,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.8 -.35 .35 .8 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -94.1,
  y: 453.1
}, "R"));

var _ref41 = /*#__PURE__*/React.createElement("text", {
  x: -68.4,
  y: 455,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.8 -.32 .32 .8 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -68.4,
  y: 455
}, "R"));

var _ref42 = /*#__PURE__*/React.createElement("text", {
  x: 112,
  y: 445.7,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.86 -.07 .07 .86 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 112,
  y: 445.7
}, "R"));

var _ref43 = /*#__PURE__*/React.createElement("text", {
  x: 180.2,
  y: 430.8,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.86 0 0 .86 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 180.2,
  y: 430.8
}, "R"));

var _ref44 = /*#__PURE__*/React.createElement("text", {
  x: 414.8,
  y: 275.2,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.75 .43 -.43 .75 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 414.8,
  y: 275.2
}, "R"));

var _ref45 = /*#__PURE__*/React.createElement("text", {
  x: 483.9,
  y: 193.1,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "rotate(39.9 153.2 471.7) scale(.86)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 483.9,
  y: 193.1
}, "E"));

var _ref46 = /*#__PURE__*/React.createElement("text", {
  x: 309.1,
  y: 414,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.83 .16 -.13 .82 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 309.1,
  y: 414
}, "O"));

var _ref47 = /*#__PURE__*/React.createElement("text", {
  x: 105.1,
  y: 459.3,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.78 -.1 .12 .84 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 105.1,
  y: 459.3
}, "O"));

var _ref48 = /*#__PURE__*/React.createElement("text", {
  x: -45.7,
  y: 455.8,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.8 -.3 .3 .8 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -45.7,
  y: 455.8
}, "A"));

var _ref49 = /*#__PURE__*/React.createElement("text", {
  x: 518.4,
  y: 144.7,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.6 .6 -.6 .6 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 518.4,
  y: 144.7
}, "A"));

var _ref50 = /*#__PURE__*/React.createElement("text", {
  x: 271.2,
  y: 388.3,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.84 .17 -.17 .84 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 271.2,
  y: 388.3
}, "A"));

var _ref51 = /*#__PURE__*/React.createElement("text", {
  x: 40.3,
  y: 455.2,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.85 -.16 .16 .85 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 40.3,
  y: 455.2
}, "M"));

var _ref52 = /*#__PURE__*/React.createElement("text", {
  x: 94.4,
  y: 448.1,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.86 -.1 .1 .86 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 94.4,
  y: 448.1
}, "P"));

var _ref53 = /*#__PURE__*/React.createElement("text", {
  x: 155.1,
  y: 437.6,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.86 0 0 .86 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 155.1,
  y: 437.6
}, "P"));

var _ref54 = /*#__PURE__*/React.createElement("text", {
  x: 405.1,
  y: 276.7,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "rotate(29.3 146.8 652.1) scale(.86)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 405.1,
  y: 276.7
}, "P"));

var _ref55 = /*#__PURE__*/React.createElement("text", {
  x: 232.1,
  y: 409.8,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.85 .1 -.1 .85 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 232.1,
  y: 409.8
}, "I"));

var _ref56 = /*#__PURE__*/React.createElement("text", {
  x: 530.4,
  y: 132.1,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "rotate(46.4 155 399.3) scale(.87)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 530.4,
  y: 132.1
}, "T"));

var _ref57 = /*#__PURE__*/React.createElement("text", {
  x: 464.2,
  y: 218.5,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "rotate(36.4 149 515.6) scale(.87)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 464.2,
  y: 218.5
}, "T"));

var _ref58 = /*#__PURE__*/React.createElement("text", {
  x: 313.7,
  y: 362,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.83 .24 -.24 .83 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 313.7,
  y: 362
}, "M"));

var _ref59 = /*#__PURE__*/React.createElement("text", {
  x: 513.7,
  y: 123.3,
  fontFamily: "Timmons",
  fontSize: 14,
  fontWeight: "bold",
  transform: "matrix(.58 .64 -.64 .58 337.3 11.7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 513.7,
  y: 123.3
}, "G"));

var _ref60 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff700",
  strokeLinecap: "round",
  strokeWidth: 1.1,
  d: "M557.4 184.5s5.2-4.4 8.9-4.6m-8.2 4c.1-.1 31-4.5 32-5.4m-31.9 5.6l34.6-3m-34.7 3.2s36.7-1.8 39 0m-39.1-.2s36 .3 36.6 1.1m-36.5-1l34.6 2.8m-35-2.6c.2 0 35.3 3 38.7 7.5m1.9 6.3c-.2-.1-12-14.2-40.7-14m.2.3s19.8 1.4 26.1 8.3m-25.8-8.5s12.9-2.5 26.3 13.7"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#gs_svg__e)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: "1pt",
  d: "M247.4 217.7s20.7.9 20.7 2.9-15.4 5.9-15.6 14.4c-.2 8.5 11.8 9.2 12.6 20 .8 10.7-9.4 12.3-11.4 15.2-2 1.4-6.9 16.6-6.3 25.5.6 9 3.3 39.2 8 45.3 3.6 2.9 9 12 15 9.2 5.9-2.9 1.8-13.2 1.2-16s2.4-7.6 2.4-11.8c0-4.3-2.2-7.8-2-8.8.2-1 16.4 3.9 15.4 20-1 16-7.5 11-7.5 11s2 19.8-3 22.4c-9.2 5-15.9-1-15.9-1l.9 4-7-3.6s-9-12.8-11-18.5-4.4-31-3.6-36.5c.8-5.5 1.4-37.6 1-39.2s-2-28.5-1-32.5 7.3-22 7.1-22z",
  transform: "matrix(.86 0 0 .86 337.3 11.7)"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff7000",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M530.8 194.4s12.4-12 19.6-10.6c3.7 0 .2 2.6.2 2.6s6.3.5 7.1 3.3c.2 1.2-3 1.6-3 1.6s2.7.5 2.8 2.8-26.5.5-26.7.3z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M531.5 193.9s13.3-1.8 18.9-7.4m-5.4 3.7s9.8-.3 9.8 1"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 1.1,
  d: "M579.7 333.1s8.4-1.9 10.7-4.9c1.4-1 8.7 11-10.7 5z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.1,
  d: "M577.5 263.8s1 6.4-2 10.8c-1.5 1.7-6.3 4.7-6.3 6.8 0 2.1 1.8 4.9 1.4 7.3s-3 5-2.7 7c0 2.1 3 13.3 2.6 13.5m-8.4-66.4s-6.6 2.3-8 9"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  fill: "#c75b00",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M559.3 190.2s2.3 6.3 9.6.4c-4.7-6.5-9.6-.2-9.6-.4z"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M564.9 190c0 .4-.4.7-.8.7s-.8-.3-.8-.6.3-.6.8-.6.8.2.8.6z"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M499.3 175.6s14 15 23 15c1.6 4.4-4.2 8.5-6.5 10.4-4.5-1.4-8.7.3-19.3-12.8.6-8.3 3-12.2 2.8-12.6zm18.8-35c1.8-5.6 5.4-10 8.5-10.5-.8-4.2 6.6-23 28-30.3 1.3 9.7-9.1 19.2-9.1 19.2s31.6-5.4 38-13.4c-.7 3.6-7.1 26-40.8 25.8 12.8 12.1-4.1 21.8-11.3 18.9 13.2-10.2-3.8-16.2-13.3-9.7z"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  fill: "#cccccd",
  fillRule: "evenodd",
  stroke: "#ccc",
  strokeWidth: 1.1,
  d: "M529 132.8c6.3-4.1 8.6-4.1 13.8-3.3l-3.7.6s-.4.5 2 2.7c-2.7-.7-5-2.2-12.2 0z"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M526.5 130.1s12.6-6.7 19.6-11.3"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  fill: "#00f",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M515.7 201s17.3 4.8 19.3-20.1c-3.8-10.8-9-34-1-40.8-7.4-5-15.4.2-15.4.2-.5 1.1-7 10.5 1.8 26.8-21-5.5-12.4 14.3-12.4 14.3.8-3.1 12-6 14.7 9.8 1.1 4-7.5 10-7 9.8z"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  fill: "#00f",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M535.1 181s18.4-9.8 17.9-32.9c-15.6.4-21.1 20.5-21.1 20.5l3.3 12.4z"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M453 179.9s-13.6 11.8-21.3 8c-5.7 3.4-12.4-2.6-12.4-2.6s7.8 29 36 8c-.5-6.4-2-13-2.3-13.4z"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  fill: "#00f",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M431.5 187.4c1.2-6 6-9 9.7-3.3 5 1 10.2-19.8-7.9-16.3 5.1-27.2-10.1-37.3-10.1-37.3s-5.4 30-3 35.6c2.5 5.6-3.5-10.3-23-14.7-.3 22.8 21.7 33.4 21.7 33.4s6.3 5.7 12.6 2.6z"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M433.3 167.6s-8.5 7.2-6.5 17m-6.4-18s-2 7 2.3 17m-3.6 2.4s4-6.4 12.4 1.8"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M420.7 141.8c0-.2-12.9 0-5.2 13-5.7 1.8-18.5-6.5-9.7-17.6-29-.7-40.7-14.6-40.7-27.4 8.5 8.9 28.8 5.3 36 10.7-8.8-8.2-7-19.5-7-19.5s24.7 7.4 29.1 29.3c-1.5 4.2-2.1 11.8-2.5 11.4z"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M400.9 119.9c4.7 4.9 17 6.3 23.2 11.7"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  fill: "#cccccd",
  fillRule: "evenodd",
  stroke: "#ccc",
  strokeWidth: 0.8,
  d: "M406.5 134.2s10.2-1.3 13 2.3c-3.9 0-5.2-1-11 1.2 1.7-.9 1.2-2.3 2.1-2.3s-3.7-1.2-4.1-1.2z"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  fill: "#923f00",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M457 54.8s5.6-4.9 11.7-.4c-2.7 8.1-12.6 5-12.6 5s.3 4.1-.7 6c2 1.6 3.6 6.5 3.6 6.5s10.2-2.5 12.3 2c3.9-.6 6.7 0 6.7 0s7.9-2 10.7-2c2.7 0 11.6 2.3 12.4 3.9.8 1.6 3.8 12.6 5.7 12.4 2-.1-4.7 2.7-6.5-.1-1.8-2.8-1.3 3.6-1.3 3.6s5.5 5.9 6.2 7.2c.6 1.3-3.4 12-.3 19.3-2.8.2-3 3-3 3-.1 3.3-4.2 4.2-4.2 4.2l-1-4.4-2.8 1.6 1.1-3.4s3.8-9.2 4.1-12.1c.4-3-3.4-8.2-6.3-8.2s-5.1 9.3-5.1 9.3-1.5 7-1 7.7l-2-2.3s-1.3 4.3-2.3 5.6c-1 1.3-3 1.8-3 1.8s-1.5-4.3-1-6c.4-1.6 8-8 7.3-12.5-.6-4.6 0-3.5-.2-3.6-.1-.2-3.9-3.5-4-5.3-.2-1.8-5 2.3-11.2 1-1.9 3.3-2 11.6-2 11.6s-.8 10 .6 11.2c1.3 1.1-3.3 3.6-3.3 3.6l-3.3 4.4-1.1-2.6-2.3 1.6 1.3-3.3c0-2.4 3.2-9.2 3.2-15s.4-11.8.4-11.8-6-.3-6 5.9c.3 6.2-1.4 6.5-1 8.3.3 1.8 2 6.9 1.4 8.4-.5 1.4-2.4 2-2.4 2l-.5.8s-6 2.7-6 3.9c.2 1.1 0-3.3 0-3.3l-.4-4.7s3.6-2.3 3.6-8c0-5.8-.8-6.6-.7-8 .2-1.2 1-6 .9-6.5-.2-.4-3.5 1.4-4.5 1.4s1.8-3.5 2.2-6c.3-2.4-3.3 2.4-6.3-.4 1.4-3 3.5-4 3.8-6.2s-2.3 2-4.6.3c.2-2.2 2.5-4.1 2.5-4.1s-1.9-.2-2.6 0c-1.5-.5 1.6-2.8 1.8-6 .1-3.3-1.8-4.6-1.8-4.8 0-.2-3.3-3-3.8-4.1-.5-1.1-.5-2.5-.5-2.5s-5.4 4-11.8-4.4c5.9-5 12.1-1.3 12.1-1.3s1.7-4.6 9.2-4.2c7.5.3 9 4.5 8.7 4z"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  fill: "#00f",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M498.3 139.5s13.8.4 14 7.8c.1 7.3-4.2 5.4-4.4 5.4l-10-1.2.3-12z"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  fill: "#fffeff",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M484.9 137.5s17.2-.2 16.2 7.3-5.3 6-5.3 6l-8.3-.7-2.6-12.6z"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  fill: "#00f",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M475.2 136.6l10 .9s6 .8 5.7 6.5c-.3 5.7-6.1 5.9-6.1 5.9l-9.7-.6.1-12.7z"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M451.9 139.5c-.1 0-13.9.4-14 7.8-.2 7.3 4.2 5.4 4.3 5.4l10.1-1.2-.4-12z"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  fill: "#00f",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M465.3 137.5s-17.2-.2-16.3 7.3c1 7.5 5.4 6 5.4 6l8.3-.7 2.6-12.6z"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M475 136.6l-10 .9s-6 .8-5.7 6.5c.2 5.7 6.1 5.9 6.1 5.9l9.7-.6-.2-12.7z"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  fill: "#5e0043",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M501.6 219.4s7.1-10.6 10.2-9.4c2.6.9.6 9-.7 9.8l-9.5-.4zm-49 1.9c-2.3-3.2-5.6-11.8-8.6-9.4-2.6.8-.6 9 .6 9.8l8-.4z"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M457.3 200.4s14 8.6 18.5 8.8c4.6.3 19-11.1 19-11.1"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  fill: "#5e0043",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M458.6 166.8l2.7-3.4 13.4 6.8 13.6-6 2.7 2.8-15.2 10.7-17.2-11z"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  fill: "#474747",
  fillRule: "evenodd",
  stroke: "#474747",
  strokeLinejoin: "round",
  strokeWidth: 1.1,
  d: "M448 166.6c1 1.3 9.7 11.9 11.3 20.6 1.6 8.7-.9-12-.9-12s10.7 5.3 11 8.6c.4 3.4 5.2-.2 5.4-.8l-31-20.1 4.2 3.7zm52.9-.6s-11.3 14.8-10 31c-2.3-7.8-.4-20.6-.4-20.6l-2.4 1.6s-2.6 11-5.8 12.6c-.6-1.3-.5-1.8-.5-1.8s-3.4 4.5-4.1 5c-.7.4.2 15 .2 15s1.2 10.6 2.5 10.5a45 45 0 00-3.4 1.9l-1.4-28.3 3.2-3.2s4.3-5.1 4.6-10.1c-1.9 1.5-4 2-4 2s-.5 7.1-2.1 8.1c-1.7 1-1.8 2.9-1.8 2.9l-.4-9.3L501 166z"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 1.1,
  d: "M475.1 183.1l2.2 44.6"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M447.7 204.4s5.1 3 7 12.2c16.7-1.2 22 4.7 22 4.7s13.7-6.6 20-5.4c2.3-4.7 8.7-10.7 8.7-10.7"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  fill: "#b4b6b9",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M440.7 160.7l34.4 22.6 31-21s6.5-3.5 6-6-2.8-1.6-4-1.2c-1 .5-32.4 22.7-32.4 22.7l-33.4-21s-2.4-.9-2.9.7 1 2.4 1.3 3.2z"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  fill: "#474747",
  fillRule: "evenodd",
  stroke: "#474747",
  strokeLinejoin: "round",
  strokeWidth: 1.1,
  d: "M502.3 154.9s-8.8-3.8-8.8-.5c0 3.2.2 3.5 1.6 5.6 1.4 2.1-1 3.4-1 3.4l-.9-2.3c-.5-1.4-5.2-2.4-5.6-4-.4-1.7 1-4.4-1.9-4.7a5.2 5.2 0 00-6.1 4.4 67.5 67.5 0 01-4.2 10.8l.5-17.2c6.2.4 17.7 1.8 26.6 2.8-2.7-.4 1 .2.9 1-.3.8-1.2 1-1.1.7zm-31.2-4.4c-1.6 0-9.5 1-11.5 2.1-2 1.2 3.3 3 2.6 4.6-.7 1.6-.7 4.7-3.2 4-2.5-.6-11-4.7-11.2-6.2-.2-1.4-2-1.5-2-1.5s24.1-3.2 25.3-3z"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M474.9 148.6v21.1m-16.3-46l-9.8 16.1"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#gs_svg__f)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: "1pt",
  d: "M161.8 129.7s4.9 6.7 4.3 8.6a25 25 0 014.3 7.8",
  transform: "matrix(.86 0 0 .86 337.3 11.7)"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M492.7 122.3s-9.1 12.8-8.8 13.8"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M446.2 61.4c-.2.7-1.4 1-2.6.7s-2-1.3-1.8-2c.2-.8 1.3-1 2.6-.7s2 1.3 1.8 2zm3.7-.2c.2.7 1.4 1 2.6.6s2-1.3 1.8-2c-.2-.7-1.4-1-2.6-.6s-2 1.3-1.8 2z"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff7000",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 1.1,
  d: "M556.1 326.6s-3.3.6-3.2 1-9.8.5-10 .2c-.2-.3-1.5 1.7-1.5 1.7l1.6-1s2.4 2.6 3.1 2.4c.8-.2-.3 1 0 1.1.1.2.9-.4.9-.4l16.3-.3-7.2-4.7zm6.1 5.1l-13.3.4s-3.4 3-3.6 3.7 2.2 1 2.2 1l.7 2.5 1.7-.6s11.4 1.7 21.8-.6c5.3-1.9 6.2-4.1 2.5-5.5-3.7-1.3-11.9-.9-12-1z"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#gs_svg__g)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: "1pt",
  d: "M208.4 404l28-1.3-5.3-4.4 75.7-3-2.6-6-84.7 3.3 10.2 4.8-23 .6.8 2.4-6-.2s6.6 2.6 6.9 3.7z",
  transform: "matrix(.86 0 0 .86 337.3 11.7)"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#gs_svg__h)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: "1pt",
  d: "M239.7 249.4c-2.2-1-12-2.4-22.8 4.7l.4 25s16-8.6 23.8-6.6c-.5-7.8-.5-17.8-1.4-23z",
  transform: "matrix(.86 0 0 .86 337.3 11.7)"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M410.4 291.8L353.7 348m82-56l-46 60.7m44-76.5l-61.5 74.5m-1.8-1l6-7m69-29l-23.9 32.8m-1 4.3l.6 12.6m35.2-38.2L431 356.9m20.7-2.5l10.3-16.8m-6.3-3.3l-12.4 14M452 321l-8.5 10.3m-2.4-25.3s-25.7 37.6-25.3 40.7m22.6-45.6c-.6.4-22.2 29-22.2 29m-1.2 9l-4 4.8m-4.9 7.2l-6 7.8"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  fill: "#8a9396",
  fillRule: "evenodd",
  stroke: "#2b2b2b",
  strokeWidth: 1.1,
  d: "M407.6 205.2s-1.7 5.5 0 8.2 12.7 24.9 12.7 24.9 7.5-9.2 10.2-9.5c2.7-.2 1.5 23.9 1.5 23.9s-4.5 4.2-7.2 4c-2.7-.3 6.7 9.4 6.5 17.6s-12.5 49-17 49.7c-4.4.8 2-7.4 1.8-9.7-.3-2.2-1.5-.7-2.5-3.2s1.5-6.2 1-8.7-2.8-2-3-3.7 1.5-2.3 1.2-4.2c-.2-2-3-1.5-2.7-3.3s.5-1 .3-4.2c-.3-3.2-.8 2.2-3.5 2.5-2.8.2-5 6.4-5 6.4s-5.5 7.7-11 4.3c3.3 7 .8 10-.4 10.2s1 5.4-2 5.7 2.2 11.7-1.3 12.7c3.8 1.7.8 4 .8 4s-8.6.7-6.7 11.9c-25.4-9-37.8-24.4-37.6-40 .3-15.7 5.3-29.9 17.4-35 3.5-13 9.5-27 9.5-27s-1-5.7-.3-9.4c.8-3.7 4.3-7.4 4.3-7.4s-.5-9-.3-13.5c.3-4.4 2-6.4 2.2-9 .3-2.4-.7-15 1.8-17.3 2.5-2.3 7.2-2 9.7-3.5 2.5-1.5 5.7-4.2 9-4s6 2.5 6 2.5 12 0 12.8 4.7c.8 4.8-2.5 6.5-2.5 6.5s1.8 6.7-5.7 13z"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  fill: "#cecfcf",
  fillRule: "evenodd",
  stroke: "#2b2b2b",
  strokeWidth: 1.1,
  d: "M396.9 188.1c.4.7-.5 2-2 2.8s-3 .8-3.4.1c-.4-.7.5-2 2-2.8s3-.8 3.4-.1z"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M394.8 189.3c0 .5-.4.9-1 .9-.4 0-.9-.4-.9-.8 0-.5.5-.9 1-.9s.9.4.9.9z"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2b2b2b",
  strokeWidth: 0.5,
  d: "M413 197.5s3 13.4-.7 22.8m1.5-28.7s6 7.8 5.2 17.4m-4.6-19.1c.2 0 5 4.1 4.8 7m-3.6-8.8s3.2 2.3 4 4.6"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M414 186.8s-11.5 18.8-10 30.6"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2b2b2b",
  strokeWidth: 0.5,
  d: "M414.8 186.2s-15.4 9.2-18.2 39"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.1,
  d: "M413.1 191.8l-6 4.5"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2b2b2b",
  strokeWidth: 0.5,
  d: "M390.9 226.9s8.5-35.5 23.7-40.7"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  fill: "#2b2b2b",
  fillRule: "evenodd",
  stroke: "#2b2b2b",
  strokeWidth: 1.1,
  d: "M420.5 238.9s8.2-10.3 10-9.9c2 .4 1.4 23.8 1.4 23.8s-6 4.5-7.4 4.3c-1.3-.2 6.8 11 6.6 15.2l-.3 4.2s0-2.5-2-6.5c-1.8-4-.7-8.5-13-18.6-3-6.2 6 3.8 8 2.3 1.8-1.5-3.5-14.6-3.3-14.8z"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2b2b2b",
  strokeWidth: 1.1,
  d: "M406 181s-3.5 1-4 2.4c-.4 1.4-2.4 2.8-3.5 2.4a18.9 18.9 0 01-3.1-2.2"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  fill: "#2b2b2b",
  fillRule: "evenodd",
  stroke: "#2b2b2b",
  strokeLinejoin: "round",
  strokeWidth: 1.1,
  d: "M386.5 193.1s-5.2 5.2-2.7 5.8c2.5.6 5.2-4 5.2-4s0 7.9 2.1 6.6l8.6-5.7s2.2-.2 2.7 0c.5.1 6 4.8 9.5 3-2 5.4-4.4 6-4.4 6s-3.7 4.9-8.6 3.8c-4.8-1.1-6-3.2-6-3.2s-4.1.3-5.3-1.5c-1.3-1.9-1.8-3-1.8-3s-2.3 2.4-3 1.3c-.6-1.1 0-7.5 3.7-9z"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2b2b2b",
  strokeWidth: 1.1,
  d: "M415.7 186s-9.6-2.9-12.8 1.8c-3.3 4.7-2.5 7.3-.8 7.8"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M417.1 185.7c0 1-.8 2-1.8 2s-1.8-1-1.8-2 .8-2 1.8-2 1.8.8 1.8 2z"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  fill: "#2b2b2b",
  fillRule: "evenodd",
  stroke: "#2b2b2b",
  strokeWidth: 1.1,
  d: "M389.4 210s3.9 6 8.5 7.6-3.2 3-7.8 0c-3.4-4.6-2.5-8-2.5-8s1-.8 1.8.4zm33.3 35.2s-11-15.1-14.1-16c-3.1-.8 2.4-1.5 5.7 1.8 3.4 3.2-.9-5.3-.9-5.3l9.3 19.5z"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  fill: "#2b2b2b",
  fillRule: "evenodd",
  stroke: "#2b2b2b",
  strokeLinejoin: "round",
  strokeWidth: 1.1,
  d: "M388.4 332.8c4.2-1 22.4 10.5 26.5 13.4 4 3 12.7 1 12.7 1s-4 2.5-6.5 3 7.4.7 7.4.7-23.3 6.4-47-6.1c-2.2-9.7 5-11.9 6.9-12z"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  fill: "#2b2b2b",
  fillRule: "evenodd",
  stroke: "#2b2b2b",
  strokeWidth: 1.1,
  d: "M415 249s-3-.6-4.6-2.4c-1.6-1.8-3.8-6.2-6.1-8.1s-14-8.2-18.1-7.8c-4.2.5-5.5-.4-6-1-.5-.5-2.2.3-2 2.5.4 2.1-3.1 6.9-1.9 9.1a63.5 63.5 0 008.5 11.7c1.2.3.4 5.3.4 5.3s5.3 5.4 6.7 5.7c1.3.3 2.7 1.2 2.5 2.5-.1 1.3-5.8 8.2-5.8 8.2s-6.1 3.2-6.2 5c0 1.8 1.5 5.6 6.3 6.8a45 45 0 0018.6-1c.7-1 1.8-7.8 1.3-8.4-.4-.7-3.7-2.7-5.3-2.4-1.6.3-3.1 1.6-3 1.9.2.3-2.3 1.6-2.3.4s4.8-6.6 5.3-6.2c.5.5 7.3 1.2 8.6 4.6s1.3 5.9 4.9 5.5c3.5-.3 8.5-3.6 9-10.5.4-6.9-4-11.5-5.2-12.2-1-.6-4.8-2.9-5.1-4-.3-1-1-4.4-.5-5.2z"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  fill: "#2b2b2b",
  fillRule: "evenodd",
  stroke: "#2b2b2b",
  strokeWidth: 1.1,
  d: "M350.4 279.3s11.6-3 14.6-3c3 .1 14.3 5.4 17.5 8.6 3.3 3.2 10 10.8 14.5 10.2 4.4-.7 5.6-1.6 5.6-1.6l-1.7 3.3s-3.6 1-5.4.5a19 19 0 01-8.8-5c-3.5-3.4-14.3-12.7-23.5-12-9.2.6-14.5 9.7-14.5 9.7s0-4.4.5-5.4c.3-1-2 2-2 2l3.2-7.3z"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  fill: "#2b2b2b",
  fillRule: "evenodd",
  stroke: "#2b2b2b",
  strokeWidth: 1.1,
  d: "M393 288.3c.1 0 3 .8 7.8.8s7.3-2.1 7.3-2.1l-.3-1.9.7-2.6s3.7 3.7 3.6 4.5c0 .7-1.5 1-1.5 1l-.5-1.8-1.3 1.6s-7 5.5-10.7 4.7c-3.8-.8-7.4-3.3-6.4-3.9s1.5-.4 1.4-.4zm-16.8 9.7s-4.2 0-6 .9c-2 .9-2.6 2-3.9 1.8-1.2-.1-2.2-1.8-1.8-2.4.5-1 3-2.4 7.7-2s4 1.7 4 1.7zm14.6 11.4c0-.2-.3-6.1-2.6-8.5a7 7 0 00-6.4-2.1c-1.3.3 4.7 2.9 5.3 4.6.6 1.7 2.5 6.5 2 7.7-.5 1.2-1.5-3.3-5.2-4.6s-8.7-.6-7.6 1 5.1.2 7.2 3.7 3.7 7.2 3.7 7.2l.6-2.5 2-.5.1-4.9 1-1.1z"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  fill: "#2b2b2b",
  fillRule: "evenodd",
  stroke: "#2b2b2b",
  strokeLinejoin: "round",
  strokeWidth: 1.1,
  d: "M387.8 328.5l-3.8-7.6s-1.2-4.9-4.4-6.2c-3.2-1.4-7.5-1.1-7.5.5-.1 1.7 6.8 3.7 7.3 4.6.5 1 .2 2.4-.4 2.5-.6 0-3.6-1.1-5.2-.7-1.6.3-2.5 2.4-4.8 1.8-2.3-.6-4.2-8-3.4-8.8 1-.7-1.7 1.4-2.2-.6-.5-2 .8-8-.1-8.7s-5.3-3.4-5.3-4c-.1-.4.2-29.6 24.6-5.4-10.5-12.4-14.6-11-16.5-11.2-1.4 0-10.9.9-13.3 13-2.4 12-5.2 4.5-5.2 4.5s-.5 5.2 2 6.7-1.2 5.9-1.2 5.9-4.6-11.2-3.9-16c-.9 3.9-.8 13.5 5 24a78 78 0 0029.9 21.1c8.9-13.6 8.4-15.2 8.4-15.4z"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  fill: "#8a9396",
  fillRule: "evenodd",
  stroke: "#2b2b2b",
  strokeLinejoin: "round",
  strokeWidth: 1.1,
  d: "M371.9 328.6s4.9.6 6.2 3.1a24 24 0 012 6.4c.8-1.6 1.2-3 2.8-4.2s2.8-1.4 2.8-2.2c-.1-1-5.3-6.4-7.9-6.7-2.6-.3-7.1 2.8-7.1 2.8s-.9 1.2 1.2.8z"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#8a9396",
  strokeLinecap: "round",
  strokeWidth: 1.1,
  d: "M383.1 341.4s12.8 5.9 33.8 6.2"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2b2b2b",
  strokeLinecap: "round",
  strokeWidth: 1.1,
  d: "M425.8 282.1s-1.1 10.7-9.4 32"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2b2b2b",
  strokeWidth: 1.1,
  d: "M424.1 288.7s-2.5 7.7-9.3 13.5"
});

var SvgGs = function SvgGs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124);
};

export default SvgGs;